import React from 'react';
import unsuccessful from '../../img/unsuccessful.png';
import Header from '../header/Header';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { addComplaintPosition, clearComplaintPositions, setPositions } from '../../features/complaintPositions/ComplaintPositionsSlice';
import { clearAllPositions } from '../../features/complaintPosition/ComplaintPositionSlice';
import { clearFiles } from '../../features/files/FileSlice';
import { clearProducts } from '../../features/products/productSlice';
import './UnsuccessfulComplaint.css';

const UnsuccessfulComplaint = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const customer = useSelector((state) => state.customer);
  const customerTypeId = customer.type.id;
   console.log(customerTypeId);
   
  useEffect(() => {
    function handlePageChange() {
        setCurrentPage(window.location.pathname);
    }
    window.addEventListener("popstate", handlePageChange);
    return () => {
        window.removeEventListener("popstate", handlePageChange);
    };
}, [currentPage]);


const handleNewComplaintClick = () => {
  setCurrentPage('customers');
  navigate('/customers');
  dispatch(clearComplaintPositions());
  dispatch(clearAllPositions())
  dispatch(clearFiles());
  dispatch(clearProducts());
};

const handleStart = () => {
  setCurrentPage('send');
  navigate('/');
  window.location.reload();
};
return (
  <div>
      <Header />
      <div className='unsuccessful-complaint-container'>
          <div className='send-unsuccessful-complaint-container'>
              <div className='content-unsuccessful'>
                  <div className='image-wrapper'>
                      <img className="unsuccessful-img" src={unsuccessful} />
                  </div>
                  <div className='text-unsuccessful-container'>
                      <h4 className='main-text'>Twoje zgłoszenie nie zostało wysłane.</h4>
                      <div className="body-text">
                          <p>Spróbuj ponownie wypełnić formularz.</p>
                          <p>Jeśli problem nadal występuje, skontaktuj się z naszym działem reklamacji.</p>
                      </div>
                  </div>
              </div>
          </div>
          <div className='unsuccessful-complaint-buttons-container'>
              <button className="add-new-complaint-btn">
                  <p className="add-new-complaint-text" onClick={handleNewComplaintClick}>
                      Dodaj nowe zgłoszenie
                  </p>
              </button>
              <Link className="back-to-start" style={{ textTransform: "none" }} onClick={handleStart}>
                  Wróć na stronę główną
              </Link>
          </div>
      </div>
  </div>
);

}

export default UnsuccessfulComplaint;